import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // ✅ ADD THIS
import 'bootstrap-icons/font/bootstrap-icons.css';
import AOS from 'aos';
import 'aos/dist/aos.css';


const App = () => {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <div className="overflow-hidden">
      
      <style>{`
      .team-card {
  transition: all 0.3s ease;
}

.team-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 15px 30px rgba(0,0,0,0.1);
}
        :root { --primary-blue: #0056b3; --accent-teal: #20c997; }
        .hero-gradient { background: linear-gradient(135deg, #001f3f 0%, #0056b3 100%); min-height: 90vh; }
        .glass-card { background: rgba(255, 255, 255, 0.9); backdrop-filter: blur(10px); border: 1px solid rgba(255,255,255,0.2); transition: transform 0.3s ease; }
        .glass-card:hover { transform: translateY(-10px); box-shadow: 0 15px 30px rgba(0,0,0,0.1); }
        .btn-gradient { background: linear-gradient(90deg, #20c997, #0056b3); color: white; border: none; transition: 0.3s; }
        .btn-gradient:hover { filter: brightness(1.1); color: white; transform: scale(1.05); }
        .section-title::after { content: ""; display: block; width: 60px; height: 4px; background: #20c997; margin: 15px auto; }
        .team-badge { font-size: 0.8rem; background: #e7f1ff; color: #0056b3; padding: 4px 12px; border-radius: 20px; }
      `}</style>

{/* Donate Modal */}
<div className="modal fade" id="donateModal" tabIndex="-1" aria-hidden="true">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content border-0 shadow-lg">
      <div className="modal-header bg-primary text-white">
        <h5 className="modal-title fw-bold">Support Srizan Foundation</h5>
        <button type="button" className="btn-close btn-close-white" data-bs-dismiss="modal"></button>
      </div>
      <div className="modal-body text-center p-4">
        <p className="text-muted">Your generous donations enable us to implement and sustain our programs.</p>
        
        {/* QR Code Placeholder */}
        <div className="bg-light p-3 rounded mb-3">
           <i className="bi bi-qr-code display-1"></i>
           <p className="small mt-2">Scan to Pay via UPI</p>
        </div>

        <div className="text-start bg-light p-3 rounded">
          <h6 className="fw-bold border-bottom pb-2">Bank Details</h6>
          <p className="mb-1 small"><strong>Account Name:</strong> Srizan Foundation</p>
          <p className="mb-1 small"><strong>Bank:</strong> [Your Bank Name]</p>
          <p className="mb-1 small"><strong>IFSC:</strong> [Your IFSC Code]</p>
        </div>
      </div>
      <div className="modal-footer border-0">
        <button className="btn btn-secondary rounded-pill w-100" data-bs-dismiss="modal">Close</button>
      </div>
    </div>
  </div>
</div>

      
      <nav className="navbar navbar-expand-lg navbar-dark bg-dark sticky-top py-3 shadow">
        <div className="container">
          <a className="navbar-brand fw-bold fs-3" href="#home">
            SRIZAN <span className="text-info">FOUNDATION</span>
          </a>
          <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navContent">
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navContent">
            <ul className="navbar-nav ms-auto align-items-center">
              {['About', 'Initiatives', 'Resources', 'Impact'].map((item) => (
                <li className="nav-item" key={item}>
                  <a className="nav-link px-3" href={`#${item.toLowerCase()}`}>{item}</a>
                </li>
              ))}
              <li className="nav-item ms-lg-3">
  <button 
    className="btn btn-gradient rounded-pill px-4" 
    data-bs-toggle="modal" 
    data-bs-target="#donateModal"
  >
    Donate Now
  </button>
</li>
            </ul>
          </div>
        </div>
      </nav>

      
      <header id="home" className="hero-gradient d-flex align-items-center text-white text-center text-lg-start">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7" data-aos="fade-right">
              <span className="badge bg-info mb-3 px-3 py-2 rounded-pill">EST. JULY 13, 2021</span>
              <h1 className="display-2 fw-bold mb-4">Empowering Communities, <br/><span className="text-info">Transforming Lives</span></h1>
              <p className="lead mb-5 opacity-75">We believe in the power of collective action to create lasting impact. Based in Lucknow, we address the diverse needs of underserved communities.</p>
              <div className="d-flex flex-wrap gap-3 justify-content-center justify-content-lg-start">
                <button className="btn btn-info btn-lg px-5 rounded-pill fw-bold">Explore Our Work</button>
                <button className="btn btn-outline-light btn-lg px-5 rounded-pill">Volunteer With Us</button>
              </div>
            </div>
            <div className="col-lg-5 mt-5 mt-lg-0" data-aos="zoom-in">
              <div className="p-4 glass-card rounded-4 text-dark shadow-lg">
                <h3 className="fw-bold mb-3">Our Core Values</h3>
                {['Empowerment', 'Equity', 'Sustainability', 'Collaboration'].map((v) => (
                  <div className="d-flex align-items-center mb-3" key={v}>
                    <i className="bi bi-check-circle-fill text-success fs-4 me-3"></i>
                    <span className="fw-semibold">{v}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </header>

      
     {/* --- PROGRAMMES / INITIATIVES --- */}
<section id="initiatives" className="py-5 bg-light">
  <div className="container py-5">

    {/* Heading */}
    <div className="text-center mb-5" data-aos="fade-up">
      <h2 className="display-5 fw-bold section-title">Our Programmes</h2>
      <p className="text-muted">
        Driving grassroots impact through focused, community-led initiatives.
      </p>
    </div>

    {/* Program Cards */}
    <div className="row g-4">

      {[
        {
          t: "Women Empowerment & SHGs",
          i: "bi-people-fill",
          c: "Building financial independence through self-help groups, savings, and micro-entrepreneurship.",
          points: ["Financial literacy", "Group savings", "Micro-loans & enterprises"]
        },
        {
          t: "Skill Development & Training",
          i: "bi-tools",
          c: "Providing job-oriented skills to youth and women for employment and self-reliance.",
          points: ["Tailoring & beautician", "Computer training", "Job placement support"]
        },
        {
          t: "Digital Literacy & ICT",
          i: "bi-laptop",
          c: "Bridging the digital divide with computer education and access to e-governance services.",
          points: ["Basic computer skills", "Online services access", "Digital awareness"]
        },
        {
          t: "Urban & Rural Development",
          i: "bi-buildings",
          c: "Improving living conditions through sanitation, nutrition, and infrastructure initiatives.",
          points: ["Hygiene drives", "Nutrition awareness", "Public scheme access"]
        },
        {
          t: "RTI & Citizen Awareness",
          i: "bi-file-earmark-text",
          c: "Empowering citizens with knowledge of rights and transparency tools.",
          points: ["RTI training", "Application support", "Civic awareness"]
        },
        {
          t: "MSME & Entrepreneurship",
          i: "bi-briefcase-fill",
          c: "Supporting small businesses with mentoring, market linkages, and government schemes.",
          points: ["Business mentoring", "Market access", "Startup support"]
        },
        {
          t: "Health & Hygiene",
          i: "bi-heart-pulse-fill",
          c: "Promoting preventive healthcare and awareness in underserved communities.",
          points: ["Health camps", "Menstrual hygiene", "Sanitation awareness"]
        }
      ].map((item, idx) => (
        <div 
          className="col-md-6 col-lg-4" 
          key={idx} 
          data-aos="fade-up" 
          data-aos-delay={idx * 100}
        >
          <div className="card h-100 border-0 shadow-sm p-4 rounded-4 glass-card initiative-card">

            {/* Icon */}
            <div className="mb-3 text-primary fs-1">
              <i className={item.i}></i>
            </div>

            {/* Title */}
            <h5 className="fw-bold mb-2">{item.t}</h5>

            {/* Description */}
            <p className="text-muted small">{item.c}</p>

            {/* Bullet Points */}
            <ul className="small text-muted ps-3 mb-3">
              {item.points.map((p, i) => (
                <li key={i}>{p}</li>
              ))}
            </ul>

            {/* Button */}
            {/* <button className="btn btn-link p-0 text-decoration-none fw-bold text-info mt-auto">
              Learn More →
            </button> */}

          </div>
        </div>
      ))}

    </div>

  </div>
</section>

      
      {/* ABOUT SECTION */}
<section id="about" className="py-5 bg-light">
  <div className="container py-5">

    {/* Heading */}
    <div className="text-center mb-5" data-aos="fade-up">
      <h2 className="display-5 fw-bold section-title">About Srizan Foundation</h2>
      <p className="text-muted">
        Empowering Communities, Transforming Lives
      </p>
    </div>

    {/* About Content */}
    <div className="row align-items-center g-5">
      
      <div className="col-lg-6" data-aos="fade-right">
        <p className="text-muted">
          Srizan Foundation is a registered non-governmental organization based in 
          <strong> Lucknow, Uttar Pradesh</strong>, founded on <strong>July 13, 2021</strong>. 
          Our foundation is rooted in the belief that sustainable change comes through 
          empowerment, education, and active community engagement.
        </p>

        <p className="text-muted">
          We work with marginalized and underserved communities to create opportunities 
          and improve quality of life through access to education, healthcare, livelihood, 
          and social development initiatives.
        </p>

        <p className="text-muted">
          Our work is guided by the values of <strong>transparency, equity, and compassion</strong>, 
          aiming to build a just and inclusive society.
        </p>
      </div>

      <div className="col-lg-6" data-aos="fade-left">
        <div className="p-4 bg-white rounded-4 shadow-sm">
          <h5 className="fw-bold mb-3">What We Stand For</h5>

          {[
            "Empowerment – Equipping individuals with knowledge and skills",
            "Equity – Equal opportunities for all",
            "Sustainability – Long-term community-driven solutions",
            "Collaboration – Working with partners & stakeholders",
          ].map((item, i) => (
            <div className="d-flex align-items-start mb-3" key={i}>
              <i className="bi bi-check-circle-fill text-success me-2"></i>
              <span className="small">{item}</span>
            </div>
          ))}
        </div>
      </div>
    </div>

    {/* Mission & Vision */}
    <div className="row mt-5 g-4 text-center">

      <div className="col-md-6" data-aos="zoom-in">
        <div className="p-4 bg-white rounded-4 shadow h-100">
          <i className="bi bi-bullseye text-primary fs-1 mb-3"></i>
          <h4 className="fw-bold">Our Mission</h4>
          <p className="text-muted small">
            To empower marginalized communities by providing access to education, 
            healthcare, and livelihood opportunities, enabling individuals to thrive 
            and contribute to society.
          </p>
        </div>
      </div>

      <div className="col-md-6" data-aos="zoom-in" data-aos-delay="150">
        <div className="p-4 bg-white rounded-4 shadow h-100">
          <i className="bi bi-eye-fill text-success fs-1 mb-3"></i>
          <h4 className="fw-bold">Our Vision</h4>
          <p className="text-muted small">
            A society where every individual has access to essential resources 
            and opportunities to lead a dignified and empowered life.
          </p>
        </div>
      </div>

    </div>

    {/* Objectives */}
    <div className="mt-5" data-aos="fade-up">
      <h3 className="fw-bold text-center mb-4">Our Objectives</h3>

      <div className="row g-3">

        {[
          "Promote access to quality education",
          "Improve community healthcare & awareness",
          "Support livelihood & vocational skills",
          "Empower women and youth leadership",
          "Promote social inclusion & equity",
          "Encourage environmental sustainability",
          "Build partnerships & community engagement",
        ].map((obj, i) => (
          <div className="col-md-6 col-lg-4" key={i}>
            <div className="p-3 bg-white rounded shadow-sm h-100">
              <i className="bi bi-arrow-right-circle text-info me-2"></i>
              <span className="small">{obj}</span>
            </div>
          </div>
        ))}

      </div>
    </div>

  </div>
</section>

      {/* --- EDUCATIONAL RESOURCES --- */}
{/* --- EDUCATIONAL RESOURCES --- */}
<section id="resources" className="py-5 bg-light">
  <div className="container py-5">

    {/* Heading */}
    <div className="text-center mb-5" data-aos="fade-up">
      <h2 className="display-5 fw-bold section-title">Educational Resources</h2>
      <p className="text-muted">
        Empowering communities through accessible knowledge, practical tools, and digital learning.
      </p>
    </div>

    <div className="row align-items-center g-5">

      {/* LEFT CONTENT */}
      <div className="col-lg-6" data-aos="fade-right">

        <h3 className="fw-bold mb-3">Learning Tools That Empower Communities</h3>
        <p className="text-muted">
          At Srizan Foundation, we believe education goes beyond classrooms. 
          Our resources are designed for rural populations, women, youth, 
          and community leaders to promote awareness, skills, and informed decision-making.
        </p>

        {/* Objectives */}
        <div className="mb-4">
          <h6 className="fw-bold">Our Objectives</h6>
          {[
            "Make education accessible to underserved communities",
            "Promote awareness of rights, health & livelihoods",
            "Provide simple and practical learning materials",
            "Support lifelong learning and empowerment",
          ].map((item, i) => (
            <div className="d-flex align-items-start mb-2" key={i}>
              <i className="bi bi-check-circle-fill text-success me-2"></i>
              <span className="small">{item}</span>
            </div>
          ))}
        </div>

        {/* Resource Types */}
        <div className="row g-3">

          {[
            {
              icon: "bi-file-earmark-text",
              title: "Printed Materials",
              desc: "RTI guides, SHG manuals, hygiene booklets, financial literacy"
            },
            {
              icon: "bi-laptop",
              title: "Digital Learning",
              desc: "PDFs, videos, QR-based modules, WhatsApp learning"
            },
            {
              icon: "bi-volume-up",
              title: "Audio-Visual",
              desc: "Community radio, nukkad natak scripts, explainers"
            },
            {
              icon: "bi-tools",
              title: "Community Toolkits",
              desc: "RTI formats, PRA tools, grievance templates"
            }
          ].map((item, i) => (
            <div className="col-sm-6" key={i}>
              <div className="p-3 bg-white rounded-4 shadow-sm h-100 border">
                <i className={`bi ${item.icon} fs-3 text-primary mb-2`}></i>
                <h6 className="fw-bold mb-1">{item.title}</h6>
                <p className="small text-muted mb-0">{item.desc}</p>
              </div>
            </div>
          ))}

        </div>

        <button className="btn btn-gradient mt-4 px-4 py-2 rounded-pill shadow">
          Visit Digital Learning Hub
        </button>

      </div>

      {/* RIGHT SIDE IMAGE + BENEFICIARIES */}
      <div className="col-lg-6" data-aos="fade-left">

        <img 
          src="https://images.unsplash.com/photo-1497633762265-9d179a990aa6?auto=format&fit=crop&w=800&q=80"
          className="img-fluid rounded-4 shadow-lg mb-4"
          alt="Educational Resources"
        />

        {/* Beneficiaries Card */}
        <div className="p-4 bg-white rounded-4 shadow-sm">
          <h5 className="fw-bold mb-3">Who Benefits?</h5>

          {[
            "School dropouts & adult learners",
            "Women in SHGs & micro-entrepreneurs",
            "Youth seeking skill development",
            "Community workers & local leaders",
          ].map((b, i) => (
            <div className="d-flex align-items-center mb-2" key={i}>
              <i className="bi bi-people-fill text-info me-2"></i>
              <span className="small">{b}</span>
            </div>
          ))}

        </div>

      </div>

    </div>

  </div>
</section>
      
    {/* --- IMPACT & STORIES --- */}
<section id="impact" className="py-5 bg-dark text-white">
  <div className="container py-5">

    {/* Heading */}
    <div className="text-center mb-5" data-aos="fade-up">
      <h2 className="display-5 fw-bold section-title">Real Stories. Real Change.</h2>
      <p className="opacity-75">
        Behind every initiative is a story of resilience, empowerment, and transformation.
      </p>
    </div>

    {/* Stories */}
    <div className="row g-4">

      {[
        {
          n: "Rani",
          q: "I used to survive day by day—now I plan my future.",
          s: "Barabanki",
          d: "Started her own tailoring unit after training and now supports her family independently."
        },
        {
          n: "Anil",
          q: "People used to pity me. Now they call me for work.",
          s: "Tikamgarh",
          d: "Learned electrical repair skills and now earns through local service work."
        },
        {
          n: "Sushila",
          q: "We are no longer waiting—we are leading.",
          s: "Palamu",
          d: "Became a confident SHG leader managing finances and helping women access schemes."
        },
        {
          n: "Nazma",
          q: "I thought tech was for others—now it’s my tool for expression.",
          s: "Lucknow",
          d: "After digital literacy training, she started assisting students and creating online content."
        }
      ].map((story, i) => (
        <div 
          className="col-md-6 col-lg-3" 
          key={i} 
          data-aos="zoom-in-up" 
          data-aos-delay={i * 150}
        >
          <div className="card h-100 bg-secondary border-0 p-4 text-white text-center shadow-sm">

            <i className="bi bi-quote fs-1 text-info mb-3"></i>

            <p className="fst-italic mb-3 small">
              "{story.q}"
            </p>

            <p className="small opacity-75 mb-3">
              {story.d}
            </p>

            <h6 className="fw-bold mb-0">{story.n}</h6>
            <small className="text-info">{story.s}</small>

          </div>
        </div>
      ))}

    </div>

    {/* Why Stories Matter */}
    <div className="row mt-5 align-items-center">

      <div className="col-lg-6" data-aos="fade-right">
        <h4 className="fw-bold mb-3">Why We Share These Stories</h4>

        {[
          "Inspire communities through real-life role models",
          "Show the human impact behind our initiatives",
          "Encourage participation from donors & volunteers",
          "Create a ripple effect of motivation and action"
        ].map((item, i) => (
          <div className="d-flex align-items-start mb-2" key={i}>
            <i className="bi bi-check-circle-fill text-info me-2"></i>
            <span className="small">{item}</span>
          </div>
        ))}

      </div>

      <div className="col-lg-6 text-center mt-4 mt-lg-0" data-aos="fade-left">
        <div className="p-4 bg-secondary rounded-4 shadow-sm">
          <i className="bi bi-people-fill display-4 text-info mb-3"></i>
          <h5 className="fw-bold">Voices That Inspire Change</h5>
          <p className="small opacity-75">
            Every story represents a life transformed through opportunity, 
            support, and empowerment. These voices reflect the true impact 
            of our work on the ground.
          </p>
        </div>
      </div>

    </div>

  </div>
</section>

   {/* --- TEAM SECTION --- */}
<section className="py-5 bg-light">
  <div className="container py-5">

    {/* Heading */}
    <div className="text-center mb-5" data-aos="fade-up">
      <h2 className="fw-bold display-5 section-title">Our Leadership Team</h2>
      <p className="text-muted">
        Dedicated professionals committed to driving meaningful social change.
      </p>
    </div>

    {/* Team Grid */}
    <div className="row g-4 justify-content-center">

      {[
        { name: "Sandhya Sinha", role: "President" },
        { name: "Vipin Kumar Pathak", role: "Secretary" },
        { name: "Prerna Pradhan", role: "Treasurer" },
        { name: "Prachi Bharti", role: "Member" },
        { name: "Syed Ejaz Ahmad", role: "Member" },
        { name: "Avinash Chandra", role: "Member" },
        { name: "Ramakant Tiwari", role: "Member" },
      ].map((member, i) => (
        <div 
          className="col-md-4 col-lg-3" 
          key={i} 
          data-aos="zoom-in" 
          data-aos-delay={i * 100}
        >
          <div className="card border-0 shadow-sm text-center p-4 h-100 rounded-4 team-card">

            {/* Avatar */}
            <div 
              className="mx-auto mb-3 rounded-circle d-flex align-items-center justify-content-center bg-light shadow"
              style={{ width: "90px", height: "90px" }}
            >
              <i className="bi bi-person-fill fs-1 text-secondary"></i>
            </div>

            {/* Name */}
            <h6 className="fw-bold mb-1">{member.name}</h6>

            {/* Role */}
            <span className="badge bg-info-subtle text-info px-3 py-2 rounded-pill mb-2">
              {member.role}
            </span>

            {/* Optional Description */}
            <p className="small text-muted mb-0">
              Committed to strengthening community impact and organizational growth.
            </p>

          </div>
        </div>
      ))}

    </div>

  </div>
</section>

     {/* --- FOOTER --- */}
<footer id="contact" className="bg-dark text-white pt-5 pb-3">
  <div className="container">

    <div className="row g-5">

      {/* ABOUT */}
      <div className="col-lg-4">
        <h4 className="fw-bold mb-3">SRIZAN FOUNDATION</h4>
        <p className="small opacity-75">
          Empowering communities through education, healthcare, livelihood, and 
          sustainable development initiatives. Together, we are building a more 
          inclusive and equitable society.
        </p>

        <p className="small opacity-75 mb-1">
          House No 204, Lane No 12, Sainik Nagar,
        </p>
        <p className="small opacity-75 mb-1">
          Rae Bareli Road, Lucknow – 226025, Uttar Pradesh
        </p>

        {/* Social Icons */}
        <div className="d-flex gap-3 fs-5 mt-3">
          <i className="bi bi-facebook text-info social-icon"></i>
          <i className="bi bi-twitter text-info social-icon"></i>
          <i className="bi bi-linkedin text-info social-icon"></i>
        </div>
      </div>

      {/* QUICK LINKS */}
      <div className="col-lg-4">
        <h5 className="fw-bold mb-3">Quick Links</h5>

        <ul className="list-unstyled small">
          <li><a href="#about" className="text-white text-decoration-none d-block mb-2">About Us</a></li>
          <li><a href="#initiatives" className="text-white text-decoration-none d-block mb-2">Our Programmes</a></li>
          <li><a href="#resources" className="text-white text-decoration-none d-block mb-2">Resources</a></li>
          <li><a href="#impact" className="text-white text-decoration-none d-block mb-2">Impact Stories</a></li>
        </ul>

        <h6 className="fw-bold mt-4">Get Involved</h6>
        <ul className="list-unstyled small">
          <li className="mb-2">Volunteer with Us</li>
          <li className="mb-2">Donate & Support</li>
          <li className="mb-2">Partner with Us</li>
        </ul>
      </div>

      {/* CONTACT + FORM */}
      <div className="col-lg-4">
        <h5 className="fw-bold mb-3">Contact & Updates</h5>

        <p className="small mb-2">
          <i className="bi bi-envelope me-2"></i> info.srizan@gmail.com
        </p>
        <p className="small mb-2">
          <i className="bi bi-phone me-2"></i> +91 82990 79785
        </p>
        <p className="small mb-3">
          <i className="bi bi-geo-alt me-2"></i> Lucknow, Uttar Pradesh
        </p>

        <p className="small opacity-75">
          Join our movement and stay updated with our initiatives.
        </p>

        {/* Email Form */}
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const email = e.target.emailInput.value;

            window.location.href = `mailto:info.srizan@gmail.com?subject=Join Srizan Foundation&body=Hello, I would like to stay connected. My email: ${email}`;
          }}
        >
          <div className="input-group mt-2">
            <input
              type="email"
              name="emailInput"
              className="form-control rounded-start-pill"
              placeholder="Your Email"
              required
            />
            <button
              type="submit"
              className="btn btn-info rounded-end-pill px-4"
            >
              Join
            </button>
          </div>
        </form>

      </div>

    </div>

    {/* Divider */}
    <hr className="mt-5 border-secondary" />

    {/* Bottom */}
    <div className="text-center small opacity-50">
      <p className="mb-1">
        © 2026 Srizan Foundation. All Rights Reserved.
      </p>
      <p className="mb-0">
        Built with a mission to empower communities and transform lives.
      </p>
    </div>

  </div>
</footer>
    </div>
  );
};



export default App;